/**
 * Per-area, per-treatment local copy.
 *
 * Every /<treatment>-<area> page and the rewritten /dentist-<area> hubs read from here.
 * Rule for this folder: if a paragraph would still make sense with another area's name
 * dropped into it, it does not belong here. Clinical facts (benefits, step-by-step,
 * price tables) stay shared in data/treatmentAreas.js — they are facts, not local copy.
 */
import ealing from './ealing';
import chiswick from './chiswick';
import hammersmith from './hammersmith';
import shepherdsBush from './shepherds-bush';
import kensington from './kensington';
import nottingHill from './notting-hill';
import richmond from './richmond';
import brentford from './brentford';
import gunnersbury from './gunnersbury';
import northEaling from './north-ealing';

export const localCopy = {
  ealing,
  chiswick,
  hammersmith,
  'shepherds-bush': shepherdsBush,
  kensington,
  'notting-hill': nottingHill,
  richmond,
  brentford,
  gunnersbury,
  'north-ealing': northEaling,
};

/** Copy for one /<treatment>-<area> page. */
export const getLocalCopy = (areaSlug, treatmentSlug) =>
  localCopy[areaSlug]?.treatments?.[treatmentSlug] || null;

/** Rewritten /dentist-<area> hub copy, where it exists (four hubs keep their original copy). */
export const getLocalHub = (areaSlug) => localCopy[areaSlug]?.hub || null;
